import { SET_CONTRACTS_SEARCH_CRITERIA } from '../actions/contracts.list.actions';
import Immutable from 'seamless-immutable';
export var INITIAL_STATE = Immutable({
  searchCriteria: {
    CreatedDateRange: null,
    CurrencyCode: null,
    ModifiedDateRange: null,
    PageNumber: 1,
    PageSize: 1000,
    IsActive: true,
    SearchFor: '',
    SortBy: 0,
    SortDirection: 1,
    SubtenantIds: [],
    TargetingSegmentIds: []
  }
});
export default function ContractsListReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    type = _ref.type;
  switch (type) {
    case SET_CONTRACTS_SEARCH_CRITERIA:
      return state.set('searchCriteria', payload);
    default:
      return state;
  }
}